module.exports = __webpack_public_path__ + "img/marshmallow-logo.bb536c51.png";